<template>
	<nk-service-bw-leistungen
		:leistungen="context.leistungen"
		:taggingpfad="context.taggingpfad"
	/>
</template>

<script>
import {groupBy, map} from 'lodash-es';
import TemplatesDefault from '../../mixins/templates-default';
import {useCMS, useSEO} from '#nk/composables/cms';

/**
 * @prop {array} context.leistungen
 * @prop {string} context.taggingpfad
 */
export default {
	name: 'NkTemplateServiceBwLeistungen',

	mixins: [TemplatesDefault],

	setup(ctx) {
		const page = useCMS();
		const firstChar = ctx.context.leistungen[0]?.name[0]?.toUpperCase() || '';

		useSEO({
			title: `${
				page.value.title ? page.value.title : 'Leistungen mit dem'
			} Buchstabe ${firstChar}`,
			description: `Leistungen mit dem Buchstabe ${firstChar}, ${page.value.description}`,
		});
	},

	computed: {
		sortedLeistungen() {
			const group = groupBy(this.context.leistungen, o =>
				o.name[0].toUpperCase(),
			);

			return map(group, (value, key) => ({letter: key, children: value}));
		},
	},
};
</script>
